// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Основной контейнер модального окна */
.userform-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

/* Модальное окно */
.userform-modal {
    background-color: #fff;
    width: 100%;
    max-width: 600px;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    padding: 20px;
    overflow-y: auto;
    max-height: 80vh; /* Ограничение по высоте для предотвращения выхода за пределы */
}

/* Заголовок модального окна */
.userform-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.userform-header h2 {
    font-size: 24px;
    font-weight: 600;
    color: #333;
    margin: 0;
}

.userform-close-btn {
    background: transparent;
    border: none;
    font-size: 20px;
    font-weight: bold;
    cursor: pointer;
    color: #333;
    transition: color 0.3s ease;
}

.userform-close-btn:hover {
    color: #dc3545;
}

/* Группа элементов формы */
.userform-group {
    margin-bottom: 15px;
}

/* Метки для полей */
.userform-group label {
    display: block;
    font-size: 16px;
    font-weight: 500;
    color: #555;
    margin-bottom: 8px;
}

/* Поля ввода */
.userform-input {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    border-radius: 6px;
    border: 1px solid #ccc;
    background-color: #f9f9f9;
    transition: all 0.3s ease;
}

.userform-input:focus {
    border-color: #007bff;
    background-color: #ffffff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.4);
}

/* Кнопки */
.userform-buttons {
    display: flex;
    justify-content: space-between;
    gap: 15px;
}

.userform-btn {
    padding: 10px 15px;
    font-size: 16px;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
    flex: 1 1;
}

.userform-btn:hover {
    transform: scale(1.05);
}

.userform-save-btn {
    background-color: #28a745;
    color: white;
}

.userform-save-btn:hover {
    background-color: #218838;
}

.userform-cancel-btn {
    background-color: #dc3545;
    color: white;
}

.userform-cancel-btn:hover {
    background-color: #c82333;
}

/* Блок с ошибками */
.userform-errorMessage {
    background-color: #f8d7da;
    color: #721c24;
    padding: 10px;
    margin-bottom: 15px;
    border-radius: 6px;
    border: 1px solid #f5c6cb;
}

/* Загрузка */
.userform-loading {
    text-align: center;
    font-size: 18px;
    color: #007bff;
}

/* Адаптивность */
@media (max-width: 768px) {
    .userform-modal {
        padding: 15px;
        max-width: 90%;
    }

    .userform-buttons {
        flex-direction: column;
    }

    .userform-buttons button {
        margin-top: 10px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/modules/Admin/components/UserForm.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA,mBAAmB;AACnB;IACI,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,gBAAgB;IAChB,gBAAgB,EAAE,+DAA+D;AACrF;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA,2BAA2B;AAC3B;IACI,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA,eAAe;AACf;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,0CAA0C;AAC9C;;AAEA,WAAW;AACX;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,2DAA2D;IAC3D,SAAO;AACX;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,oBAAoB;AACpB;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA,aAAa;AACb;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["/* Основной контейнер модального окна */\r\n.userform-container {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(0, 0, 0, 0.4);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 9999;\r\n}\r\n\r\n/* Модальное окно */\r\n.userform-modal {\r\n    background-color: #fff;\r\n    width: 100%;\r\n    max-width: 600px;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\r\n    padding: 20px;\r\n    overflow-y: auto;\r\n    max-height: 80vh; /* Ограничение по высоте для предотвращения выхода за пределы */\r\n}\r\n\r\n/* Заголовок модального окна */\r\n.userform-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.userform-header h2 {\r\n    font-size: 24px;\r\n    font-weight: 600;\r\n    color: #333;\r\n    margin: 0;\r\n}\r\n\r\n.userform-close-btn {\r\n    background: transparent;\r\n    border: none;\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n    cursor: pointer;\r\n    color: #333;\r\n    transition: color 0.3s ease;\r\n}\r\n\r\n.userform-close-btn:hover {\r\n    color: #dc3545;\r\n}\r\n\r\n/* Группа элементов формы */\r\n.userform-group {\r\n    margin-bottom: 15px;\r\n}\r\n\r\n/* Метки для полей */\r\n.userform-group label {\r\n    display: block;\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    color: #555;\r\n    margin-bottom: 8px;\r\n}\r\n\r\n/* Поля ввода */\r\n.userform-input {\r\n    width: 100%;\r\n    padding: 10px;\r\n    font-size: 16px;\r\n    border-radius: 6px;\r\n    border: 1px solid #ccc;\r\n    background-color: #f9f9f9;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.userform-input:focus {\r\n    border-color: #007bff;\r\n    background-color: #ffffff;\r\n    box-shadow: 0 0 5px rgba(0, 123, 255, 0.4);\r\n}\r\n\r\n/* Кнопки */\r\n.userform-buttons {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    gap: 15px;\r\n}\r\n\r\n.userform-btn {\r\n    padding: 10px 15px;\r\n    font-size: 16px;\r\n    border-radius: 6px;\r\n    border: none;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease, transform 0.2s ease;\r\n    flex: 1;\r\n}\r\n\r\n.userform-btn:hover {\r\n    transform: scale(1.05);\r\n}\r\n\r\n.userform-save-btn {\r\n    background-color: #28a745;\r\n    color: white;\r\n}\r\n\r\n.userform-save-btn:hover {\r\n    background-color: #218838;\r\n}\r\n\r\n.userform-cancel-btn {\r\n    background-color: #dc3545;\r\n    color: white;\r\n}\r\n\r\n.userform-cancel-btn:hover {\r\n    background-color: #c82333;\r\n}\r\n\r\n/* Блок с ошибками */\r\n.userform-errorMessage {\r\n    background-color: #f8d7da;\r\n    color: #721c24;\r\n    padding: 10px;\r\n    margin-bottom: 15px;\r\n    border-radius: 6px;\r\n    border: 1px solid #f5c6cb;\r\n}\r\n\r\n/* Загрузка */\r\n.userform-loading {\r\n    text-align: center;\r\n    font-size: 18px;\r\n    color: #007bff;\r\n}\r\n\r\n/* Адаптивность */\r\n@media (max-width: 768px) {\r\n    .userform-modal {\r\n        padding: 15px;\r\n        max-width: 90%;\r\n    }\r\n\r\n    .userform-buttons {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .userform-buttons button {\r\n        margin-top: 10px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
